import {Page} from 'page/utils';
import SegmentUtils from 'utils/segment';
import getFilters from '../utils/filters';
import getParkingType from '../utils/parking-type';
import getTopSearchResults from '../utils/top-search-results';

export default function trackProductListFiltered({
    citySlug,
    pageType,
    isMonthly,
    spots,
    filters,
    sortBy,
}) {
    const isEvent = pageType === Page.EVENT;
    const isAirport = pageType === Page.AIRPORT;
    const parkingType = getParkingType({isMonthly, isAirport, isEvent});
    const {filteredSpots} = getTopSearchResults({
        spots,
        filters,
        isMonthly,
        sortBy,
    });
    const properties = {
        city: citySlug,
        filters: getFilters(filters),
        parking_type: parkingType,
        products: filteredSpots.map(
            ({parking_spot_id, title, selectedRate}) => {
                return {
                    category: parkingType,
                    name: title,
                    price: selectedRate.price,
                    product_id: String(parking_spot_id),
                    quantity: 1,
                };
            }
        ),
        via_quick_filter: filters.viaQuickFilter,
    };

    SegmentUtils.track({
        event: 'Product List Filtered',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 1,
                },
            },
        },
    });
}
